module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "data-list-heading"
  }, [_c('div', {
    staticClass: "data-list-statusbar"
  }, [_c('div', {
    staticClass: "data-list-statusbar__contains data-list-statusbar__block"
  }, [_vm._v(_vm._s(_vm.tags.length) + " topics")])]), _vm._v(" "), _c('a', {
    staticClass: "data-list-add",
    class: [{
      'data-list-add__close': _vm.addFormDisplay
    }],
    attrs: {
      "href": "#",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.displayAddForm()
      }
    }
  }, [_vm._v("Add new topic")])]), _vm._v(" "), (_vm.addFormDisplay) ? _c('div', {
    staticClass: "categories-add-form"
  }, [_c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "input-category-name"
    }
  }, [_vm._v("Topic name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTag.name),
      expression: "newTag.name"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "text",
      "id": "input-category-name"
    },
    domProps: {
      "value": (_vm.newTag.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newTag, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "input-category-icon"
    }
  }, [_vm._v("Topic icon")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTag.icon),
      expression: "newTag.icon"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "text",
      "id": "input-category-icon"
    },
    domProps: {
      "value": (_vm.newTag.icon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newTag, "icon", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTag.featured),
      expression: "newTag.featured"
    }],
    staticClass: "form-control form-control__checkbox background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "checkbox",
      "id": "new-featured"
    },
    domProps: {
      "checked": Array.isArray(_vm.newTag.featured) ? _vm._i(_vm.newTag.featured, null) > -1 : (_vm.newTag.featured)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newTag.featured,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newTag, "featured", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newTag, "featured", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newTag, "featured", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-featured"
    }
  }, [_vm._v("Featured")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "textarea-category-desc"
    }
  }, [_vm._v("Topic description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTag.description),
      expression: "newTag.description"
    }],
    staticClass: "form-control form-control__textarea",
    staticStyle: {
      "height": "140px"
    },
    attrs: {
      "name": "category-desc",
      "id": "textarea-category-desc",
      "cols": "30",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.newTag.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newTag, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('a', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeAddForm()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createTag()
      }
    }
  }, [_vm._v("Create topic")])]), _vm._v(" "), _c('hr', {
    staticClass: "add-form-delimiter"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "cellpadding tag-list-body__head_id table-head-ceil id-column"
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "categories-list-search-col text-left tag-list-body__head_search table-head-ceil"
  }, [_c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "table-search",
    attrs: {
      "type": "search",
      "placeholder": "Search in topics..."
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  })])]), _vm._v(" "), _c('th', {
    staticClass: "cellpadding tag-list-body__head_actions table-head-ceil",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.updatedTags), function(tag) {
    return _c('tr', [(tag.type === 'show') ? _c('td', {
      staticClass: "text-center cellpadding text-center"
    }, [_vm._v("\n            " + _vm._s(tag.id) + "\n          ")]) : _vm._e(), _vm._v(" "), (tag.type === 'show') ? _c('td', {
      staticClass: "cellpadding"
    }, [_vm._v(_vm._s(tag.name))]) : _vm._e(), _vm._v(" "), (tag.type === 'show') ? _c('td', {
      staticClass: "cellpadding text-center action-column"
    }, [_c('button', {
      staticClass: "table-crud-btn icon-btn edit-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showEditionForm(tag.id)
        }
      }
    }, [_c('span', {
      staticClass: "table-tooltip"
    }, [_vm._v("Edit")])])]) : _vm._e(), _vm._v(" "), (tag.type === 'show') ? _c('td', {
      staticClass: "cellpadding text-center action-column"
    }, [_c('button', {
      staticClass: "table-crud-btn icon-btn delete-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeTag(tag.id)
        }
      }
    }, [_c('span', {
      staticClass: "table-tooltip"
    }, [_vm._v("Remove")])])]) : _vm._e(), _vm._v(" "), (tag.type === 'edit') ? _c('td', {
      staticClass: "edit-row",
      attrs: {
        "colspan": "4"
      }
    }, [_c('div', {
      staticClass: "wrap-edit-form",
      staticStyle: {
        "display": "block"
      }
    }, [_c('div', {
      staticClass: "row-edit-form",
      staticStyle: {
        "max-width": "unset",
        "margin-bottom": "32px",
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "wrap-title-input",
      staticStyle: {
        "max-width": "140px"
      }
    }, [_c('div', {
      staticClass: "form-element",
      staticStyle: {
        "margin": "0 !important"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tag.featured),
        expression: "tag.featured"
      }],
      staticClass: "form-control form-control__checkbox background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "checkbox",
        "id": "edit-featured"
      },
      domProps: {
        "checked": Array.isArray(tag.featured) ? _vm._i(tag.featured, null) > -1 : (tag.featured)
      },
      on: {
        "change": function($event) {
          var $$a = tag.featured,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(tag, "featured", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(tag, "featured", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(tag, "featured", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "edit-featured"
      }
    }, [_vm._v("Featured")])])]), _vm._v(" "), _c('div', {
      staticClass: "wrap-title-input",
      staticStyle: {
        "max-width": "unset"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tag.name),
        expression: "tag.name"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "placeholder": "Name"
      },
      domProps: {
        "value": (tag.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(tag, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wrap-title-input",
      staticStyle: {
        "max-width": "unset"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tag.icon),
        expression: "tag.icon"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "placeholder": "Icon"
      },
      domProps: {
        "value": (tag.icon)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(tag, "icon", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wrap-desc-textarea",
      staticStyle: {
        "max-width": "unset"
      }
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tag.description),
        expression: "tag.description"
      }],
      staticClass: "form-control form-control__textarea",
      attrs: {
        "name": "desc-textarea",
        "cols": "10",
        "rows": "3",
        "placeholder": "Description"
      },
      domProps: {
        "value": (tag.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(tag, "description", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "wrap-table-control-panel",
      staticStyle: {
        "width": "100%",
        "text-align": "right"
      }
    }, [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.discardСhanges(tag.id)
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editTag(tag.id)
        }
      }
    }, [_vm._v("Save")])])])]) : _vm._e()])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-users-page test-class"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Topics list")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46831627","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/TagsList.vue
// module id = 923
// module chunks = 1